import React from 'react'

function LandingPage() {
  return (
    <div className="mt-20 ml-20 text-lg" >
      Landing page
    </div>
  )
}

export default LandingPage
